import formatStringByPattern from 'format-string-by-pattern';
import numeral from 'numeral';
import { MONEY_TYPES } from './format-money.js';
import { PERCENTAGE_TYPES } from './format-percentage.js';

const phoneNumberMask = value => {
  if (!value) return value;
  const onlyNumbers = value.replace(/[^\d]/g, '');
  // TODO: LENGHT GOING HIGHER THAN 10!
  if (!onlyNumbers?.length || onlyNumbers.length > 10) {
    throw new Error('');
  }
  return formatStringByPattern('(999) 999 - 9999', onlyNumbers);
};
const phoneNumberUnmask = value => {
  if (!value) return value;
  return value.replace(/\D+/g, '');
};
const currencyMask = value => {
  if (!value) return value;
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers?.length) throw new Error('');
  return numeral(onlyNumbers).format(MONEY_TYPES.DEFAULT);
};
const currencyUnmask = value => {
  if (!value) return value;
  return value.replace(/\D+/g, '');
};
const numericMask = maxLen => value => {
  if (!value) return value;
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers?.length) throw new Error('');
  if (maxLen && onlyNumbers.length > maxLen) throw new Error('');
  return value;
};
const numericUnmask = value => {
  return value;
};
const floatNumericMask = value => {
  if (!value) {
    return value;
  }
  const onlyNumbers = value.toString().replace(/[^\d]/g, '');
  return onlyNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const unmaskFloatNumeric = value => {
  if (!value) {
    return value;
  }
  return value.replace(/[^\d]/g, '');
};
const creditCardNumberMask = value => {
  if (!value) {
    return value;
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers) {
    return onlyNumbers;
  }
  const isAmex = /^34/.test(onlyNumbers) || /^37/.test(onlyNumbers);
  if (isAmex) {
    return formatStringByPattern('9999 999999 99999', onlyNumbers);
  }
  return formatStringByPattern('9999 9999 9999 9999', onlyNumbers);
};
const creditCardNumberUnmask = value => {
  if (!value) {
    return value;
  }
  return value.replace(/\s/g, '');
};
const MMYYMask = value => {
  if (!value || value.includes('/') && value.length < 5 || typeof value === 'object') {
    return value;
  }
  const onlyNumbers = value?.replace(/[^\d]/g, '');
  if (!onlyNumbers) {
    return onlyNumbers;
  }
  return formatStringByPattern('99/99', onlyNumbers);
};
const MMYYUnmask = value => {
  if (typeof value === 'object') {
    return value;
  }
  if (value.length > 5) {
    return value.substr(0, 4);
  }
  return value;
};
const maskYYYY = value => {
  if (!value) {
    return value;
  }
  const onlyNumbers = value.toString().replace(/[^\d]/g, '');
  return onlyNumbers;
};
const unmaskYYYY = value => {
  if (typeof value === 'string' && value.length > 4) {
    return value.substr(0, 4);
  }
  return value;
};
const MMYYYYMask = value => {
  if (!value || value.includes('/') && value.length < 7 || typeof value === 'object') {
    return value;
  }
  const onlyNumbers = value?.replace(/[^\d]/g, '');
  if (!onlyNumbers) {
    return onlyNumbers;
  }
  return formatStringByPattern('99/9999', onlyNumbers);
};
const MMYYYYUnmask = value => {
  if (typeof value === 'object') {
    return value;
  }
  if (value.length > 7) {
    return value.slice(0, 6);
  }
  return value;
};
const dateMMDDYYYYmask = value => {
  if (!value || value.includes('/') && value.length < 6) {
    return value;
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers?.length || onlyNumbers.length > 8) {
    throw new Error('');
  }
  return formatStringByPattern('99/99/9999', onlyNumbers);
};
const dateMMDDYYYYunmask = value => {
  if (value.length > 10) {
    return value.slice(0, 10);
  }
  return value;
};
const dateMMDDYYmask = value => {
  if (!value || value.includes('/') && value.length < 6) {
    return value;
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers?.length || onlyNumbers.length > 6) {
    throw new Error('');
  }
  return formatStringByPattern('99/99/99', onlyNumbers);
};
const dateMMDDYYunmask = value => {
  if (value.length > 8) {
    return value.slice(0, 8);
  }
  return value;
};
const percentageMask = value => {
  if (!value) return value;
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers?.length) throw new Error('');
  numeral.options.scalePercentBy100 = false;
  return numeral(onlyNumbers).format(PERCENTAGE_TYPES.NO_DECIMAL);
};
const percentageUnmask = value => {
  if (!value) return value;
  return value.replace(/\D+/g, '');
};
const maskMMYY = value => {
  if (!value || value.includes('/') && value.length < 5 || typeof value === 'object') {
    return value;
  }
  const onlyNumbers = value?.replace(/[^\d]/g, '');
  if (!onlyNumbers) {
    return onlyNumbers;
  }
  return formatStringByPattern('99/99', onlyNumbers);
};
const unmaskMMYY = value => {
  if (typeof value === 'object') {
    return value;
  }
  if (value.length > 5) {
    return value.substr(0, 4);
  }
  return value;
};
const maskCreditCardNumber = value => {
  if (!value) {
    return value;
  }
  const onlyNumbers = value.replace(/[^\d]/g, '');
  if (!onlyNumbers) {
    return onlyNumbers;
  }
  const isAmex = /^34/.test(onlyNumbers) || /^37/.test(onlyNumbers);
  if (isAmex) {
    return formatStringByPattern('9999 999999 99999', onlyNumbers);
  }
  return formatStringByPattern('9999 9999 9999 9999', onlyNumbers);
};
const unmaskCreditCardNumber = value => {
  if (!value) {
    return value;
  }
  return value.replace(/\s/g, '');
};
const maskSSN = value => {
  if (!value || value.includes('-') && value.length < 8) {
    return value;
  }
  return formatStringByPattern('999-99-9999', value);
};
const unmaskSSN = value => {
  if (!value) {
    return value;
  }
  return value.replace(/\D+/g, '').slice(0, 9);
};
const maskEIN = value => {
  if (!value || value.includes('-') && value.length < 3) {
    return value;
  }
  return formatStringByPattern('99-9999999', value);
};
const unmaskEIN = value => {
  if (!value) {
    return value;
  }
  return value.replace(/\D+/g, '').slice(0, 9);
};

export { MMYYMask, MMYYUnmask, MMYYYYMask, MMYYYYUnmask, creditCardNumberMask, creditCardNumberUnmask, currencyMask, currencyUnmask, dateMMDDYYYYmask, dateMMDDYYYYunmask, dateMMDDYYmask, dateMMDDYYunmask, floatNumericMask, maskCreditCardNumber, maskEIN, maskMMYY, maskSSN, maskYYYY, numericMask, numericUnmask, percentageMask, percentageUnmask, phoneNumberMask, phoneNumberUnmask, unmaskCreditCardNumber, unmaskEIN, unmaskFloatNumeric, unmaskMMYY, unmaskSSN, unmaskYYYY };
